// extracted by mini-css-extract-plugin
export default {"root":"VerticalLabel_root__5Eazw","label":"VerticalLabel_label__n53W8","value":"VerticalLabel_value__-GwG7"};